<div class="container">
  <h1 class="title">Creator Partner Program</h1>

  <div class="content">
    <p class="intro">
      Join our exclusive Creator Partner Program and unlock amazing benefits!
    </p>

    <div class="benefits">
      <h2>What you'll receive:</h2>
      <ul>
        <li>Free credits to use on {{ environment.domain }}</li>
        <li>Early access to new features before public release</li>
        <li>Direct support from our team</li>
      </ul>
    </div>

    <div class="contact">
      <h2>Ready to join?</h2>
      <p>To join our Creator Partner Program, email us at:</p>
      <a href="mailto:hello@{{ environment.domain }}" class="email-link"
        >hello&#64;{{ environment.domain }}</a
      >
      <p class="note">
        Include your social media profiles and tell us about your content.
      </p>
    </div>
  </div>
</div>
